import { Trans, useLingui } from "@lingui/react/macro";

import LogoIcon from "@/assets/icons/logo.svg?react";

import InformativeText from "../informative-text";

export default function TeamSection() {
  const { i18n } = useLingui();

  return (
    <section className="mb-[60px] rounded-4xl bg-(--color-bg-color-bg-dark-beige) py-8 md:mt-[60px] md:mb-[120px]">
      <div className="container">
        <div className="mb-8 flex items-center justify-between">
          <h2 className="text-4xl lg:text-5xl">
            <Trans>
              Who is<span className="font-medium md:block"> Behind the company</span>
            </Trans>
          </h2>
          <LogoIcon className="hidden lg:block" />
        </div>

        <div className="flex flex-col justify-between">
          <InformativeText text={i18n._("Founders")} className="mb-2" />
          <h4 className="mb-4 text-xl font-semibold">
            {i18n._("Mohamed Nassif")} - {i18n._("Hassan Nassif")} - {i18n._("Bahira Nassif")}
          </h4>
          <p className="text-text-medium">
            {i18n._(
              "At the heart of El Safwa is a team of founders whose shared vision blends innovation, hospitality, and expertise. Guided by a passion for excellence, they have crafted a brand that elevates serviced living into an experience of comfort, warmth, and modern sophistication. With a balance of creative foresight, guest-centered care, and decades of real estate expertise, they have established El Safwa as a trusted name, where every detail reflects a commitment to quality and a new standard of contemporary living.",
            )}
          </p>
        </div>
      </div>
    </section>
  );
}
